import React from "react"
import { Grid } from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import BackButton from "atoms/button/BackButton"
import useReturnToService from "organisms/agreementSelection/useReturnToService"

const useStyle = makeStyles(theme => ({
  backButton: {
    paddingTop: "58px",
    paddingBottom: "30px",
    [theme.breakpoints.up("sm")]: {
      paddingTop: "47px",
      paddingBottom: "30px",
    },
  },
}))

const BottomContents = () => {
  const classes = useStyle()
  const [returnToService, returnLabel] = useReturnToService()

  return (
    <Grid container direction="column" alignItems="center">
      <Grid item className={classes.backButton}>
        <BackButton
          id="AgreementSelectionContents.BackButton"
          onclick={returnToService}
          title={returnLabel}
          ga="agreementSelectionBackButton"
        />
      </Grid>
    </Grid>
  )
}

export default BottomContents
